import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  GuardResult,
  Router,
  RouterStateSnapshot,
} from "@angular/router";

import { UserService } from "src/app/services";
import { environment } from "src/environments/environment";

/** Authorisation guard */
export const optionsAdminGuard: CanActivateFn = async (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<GuardResult> => {
  const router = inject(Router);
  const us = inject(UserService);

  const loggedIn = await us.getCurrentUser();
  const isPremium = us.isPremium();
  const isAdmin = us.isAdmin();

  const isBillingRoute = next.url.some((segment) => segment.path === "billing");

  if (!environment.production) {
    console.log("OptionsAdminGuard loggedIn", loggedIn && isPremium && isAdmin);
  }

  if (loggedIn && isPremium && isAdmin) {
    return true;
  } else if (loggedIn && !isPremium && isAdmin && isBillingRoute) {
    return true;
  } else {
    const tenantGuid = next.params["tenantid"];
    return router.createUrlTree(["/", tenantGuid, "options"]);
  }
};
